import React from 'react';
import './Team.css';

const Team = () => {
  const teams = {
    texas: {
      name: '🤠 Texas Team',
      members: [
        {
          id: 1,
          name: 'Austin Yao',
          location: 'Dallas, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'Hi, I\'m Austin, a high school student in the class of 2029 with a passion for swimming. I have been swimming since I was 3 years old and currently train with Lakeside Aquatic Club, specializing in breaststroke. Recently, I achieved two Sectionals cuts in the 100m and 200m breaststroke and have qualified for TAGS (Texas Age Group Swimming) twice. At the Long Course TAGS meet, I competed on both A medley relay teams. I have swam on both the Mason Manta Rays and North Texas Nadadores, whose members help make up the Ohio and Texas chapters of our organization. Outside of the pool, I enjoy playing the violin, solving math problems, and playing chess.',
          picture: '/team-photos/austinProfilePicture.jpg'
        },
        {
          id: 2,
          name: 'Rebecca Yao',
          location: 'Dallas, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'I\'m Rebecca, and I\'m in the class of 2031. I currently swim for Lakeside Aquatic Club and I used to swim for the Mason Manta Rays in Ohio. I have been swimming for over eight years, and its become my favorite sports out of three sports I\'ve tried when I was little. My best stroke is backstroke and this long course season I got the 50 back TAGS and 100 back TAGS Bonus. I\'ve been with this program since we started in Mason, Ohio, and its been quite a journey from starting the program to expanding it to here, in Texas. Other hobbies I have include reading, writing, and playing with my two cats.',
          picture: '/team-photos/rebeccaProfilePicture.jpg'
        },
        {
          id: 8,
          name: 'Aiden Ji',
          location: 'Frisco, TX',
          club: 'Metroplex Aquatics',
          bio: 'I\'m Aiden, a high school student in the class of 2030 who goes to St. Mark\'s School of Texas. I\'ve been swimming since I was 5 years old and currently swim for Metroplex Aquatics. My main stroke is breaststroke, qualifying for TAGS in the 100 Breast. Outside of the pool, I enjoy watching and following sports and playing the cello.',
          picture: '/team-photos/aidenProfilePicture.jpg'
        },
        {
          id: 9,
          name: 'Olivia Ye',
          location: 'Coppell, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'I\'m Olivia, I\'m in the class of 2031, and I swim for Lakeside Aquatic Club. I started and grew a passion for swimming when I was around 4 and a half. My best stroke is breaststroke, although my favorite is freestyle. Some milestones and memorable moments include getting team records on my old team (Waterloo Swimming), my team getting overall first place at TAGS (Texas Age Group Swimming Championships), and being there on the sidelines to cheer others on. Some things I enjoy doing outside of school are reading, math, piano, and hanging out with my friends.',
          picture: '/team-photos/oliviaProfilePicture.jpg'
        },
        {
          id: 13,
          name: 'Lucas Sun',
          location: 'Southlake, TX',
          club: 'North Texas Natadores',
          bio: 'I\'ve been swimming for the past eight years, dedicating countless hours to training and improvement. I was part of the NTN swim club, where I developed strong technique and discipline. My hard work paid off when I earned a spot on the Southlake Carroll varsity swim team, a milestone that reflects my growth and commitment to the sport.',
          picture: '/team-photos/lucasProfilePicture.jpg'
        },
        {
          id: 14,
          name: 'Valentina Calderon',
          location: 'Highland Park, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'I\'m Valentina, I\'m a high school student in the class of 2030 and I swim for Lakeside Aquatic Club. I have been swimming for seven years and my favorite strokes are freestyle and backstroke. Some of my accomplishments are going to TAGS (Texas Age Group Swimming Championships) and holding multiple school records. I love swimming and am dedicated and appreciate the friends, experiences, and lessons it has given me!',
          picture: '/team-photos/valentinaProfilePicture.jpg'
        },
        {
          id: 15,
          name: 'Angela Guo',
          location: 'Dallas, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'I\'m Angela Guo, I\'m in the class of 2032, and I swim for Lakeside Aquatic Club. I love swimming, and my favorite strokes are butterfly and backstroke. Some highlights of my swim journey include breaking team records and winning the 2024 Long Course TAGS championship in the 100 freestyle and 100 butterfly. I also have previous experience coaching swimming, and I am super excited to meet all of you!',
          picture: '/team-photos/angelaProfilePicture.jpg'
        },
        {
          id: 16,
          name: 'Vivianne Wang',
          location: 'Dallas, TX',
          club: ' Dallas Mustangs Club',
          bio: 'I\'m Vivianne, I am a high school student in the class of 2030 at Greenhill School. I have been a club swimmer since I was 7, and I began training with a summer team when I was 5. At the moment, I swim for the Dallas Mustangs. In addition, I currently hold mostly A time standards and my best races are 50 free, 50 back, and 100 free. Outside of the natatorium, my hobbies include debate and hanging out with my friends.',
          picture: '/team-photos/vivianneProfilePicture.png'
        },
        {
          id: 17,
          name: 'Charles Chen',
          location: 'Dallas, TX',
          club: 'Lakeside Aquatic Club',
          bio: 'I\'m Charles, I am in the class of 2034 at Greenhill School. I am passionate about swimming and have qualified for all events at the Texas Age Group Swimming (TAGS) Championships in both Short Course and Long Course seasons. I enjoy challenging myself in the pool and continuously working to improve.Some of my recent achievements include:2025 IMX Top Score Award Winner (Boys 9–10 Age Group, Long Course and Short Course Divisions),2025–2026 Iron Heart Award Recipient, MAC Holiday Invitational High Point Champion,Swimming has taught me discipline, perseverance, and goal-setting. I look forward to continuing to grow as both an athlete and a student.',
          picture: '/team-photos/CharlesChen.jpg'
        }
      ]
    },
    ohio: {
      name: '🌽 Ohio Team',
      members: [
        {
          id: 6,
          name: 'Sharon Li',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Hi, I\'m Sharon. I\'m a high school student in the class of 2029 and I swim for the Mason Manta Rays. I\'ve been swimming for 5 and a half years, and my favorite stroke is breaststroke. I\'ve gotten several JC cuts in the past especially in breaststroke and backstroke. Through swimming, I\'ve learned to push myself hard while enjoying the sport. When I\'m not swimming, I like to read, write, and hang out with friends.',
          picture: '/team-photos/sharonProfilePicture.jpg'
        },
        {
          id: 5,
          name: 'Caleb Tan',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Hi, I\'m Caleb, a high school student in the class of 2029, and I\'ve been swimming competitively for 8 years. I\'m currently swimming for the Mason Manta Rays. My favorite strokes are backstroke and breaststroke. I currently hold multiple team individual and relay records. When I\'m not swimming, I like to watch movies, play Go, or read a book.',
          picture: '/team-photos/calebProfilePicture.jpg'
        },
        {
          id: 3,
          name: 'Andrew Zhang',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'I\'m Andrew, and I\'m a high school student in the class of 2030 who loves swimming on the Mason Manta Rays. I\'ve been swimming since the age of 5 and have been passionate about it ever since! My favorite stroke is breastroke and individual medleys. I currently hold 12 individual short-course team records for the 9-10 and 11-12 age groups and one long-course team record. I\'ve also recently gotten two sectionals, 100 and 200 breast at 13. I\'m excited to both teach and learn and when I\'m not swimming, I like playing video games and exploring music.',
          picture: '/team-photos/andrewProfilePicture.jpg'
        },
        {
          id: 7,
          name: 'Victor Cao',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Hi, I\'m Victor Cao, and I\'m in the class of 2031 who swims with the Mason Manta Rays. I have been swimming competitively for 4 years, and my best strokes are breaststroke and freestyle. Recently, I achieved two Zones/AAA cuts for both 50 free and 50 breast. I currently hold one team relay record for the 4x50 freestyle relay. When I\'m not swimming, I like playing video games and Rubik\'s Cubing.',
          picture: '/team-photos/victorProfilePicture.jpg'
        },
        {
          id: 4,
          name: 'Bryan Zhang',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Patient coach who excels at teaching beginners and building strong foundations! 🌟',
          picture: '/team-photos/bryanProfilePicture.jpg'
        },
        {
          id: 15,
          name: 'Claire Liu',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Hi, My name is Claire and I\'m currently a high school student in the class of 2029 in Mason Highschool. As a proud swimmer of the Mason Manta Rays, my devotion and commitment to this sport has allowed me to achieve top age group times and compete at high level meets like zones (in which I competed 4 consecutive years in.) My best stroke is Butterfly, and I\'m striving for the 100 fly sectional though I also have zone cuts for freestyle. Besides swimming, I also ran track and qualified for states, and I enjoy hanging out with friends during my free time.',
          picture: '/team-photos/claireProfilePicture.jpg'
        },
        {
          id: 16,
          name: 'Anna Yu',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: 'Dedicated coach who excels at helping swimmers build confidence and technique! 🌟',
          picture: '/team-photos/annaProfilePicture.jpg'
        },
        {
          id: 17,
          name: 'Fiona Wang',
          location: 'Mason, OH',
          club: 'Mason Manta Rays',
          bio: "Hi, I'm Fiona Wang, I'm a high school student in the class of 2031 who has been swimming for the Mason Manta Rays since 6. My best strokes are butterfly and backstroke. Last year I made Zones (AAA) for 100 free. I've also gotten several JC cuts since I was 8. When I'm not swimming, I enjoy hanging out with my friends and watching movies or TV shows",
          picture: '/team-photos/FionaWang.png'
        }
      ]
    },
    california: {
      name: '🌴 California Team',
      members: [
        {
          id: 17,
          name: 'Yimo Liu',
          location: 'California',
          club: 'Pacific Swim',
          bio: 'Hi! My name is Yimo Liu and I\'ve been competitively swimming for 5 years. I\'m a high school student in the class of 2029 and going into Westview High School. I swim for Pacific swim and I\'m a backstroker. My current goal is to make it to Far Westerns before I turn 15.',
          picture: '/team-photos/Yimo.jpg'
        },
        {
          id: 18,
          name: 'Connor Ho',
          location: 'California',
          club: 'Pacific Swim',
          bio: 'Patient coach who excels at teaching beginners and building strong foundations! 🌟',
          picture: '/team-photos/ConnerProfilePicture.png'
        },
        {
          id: 19,
          name: 'Katie An',
          location: 'California',
          club: 'Pacific Swim',
          bio: 'Hi, my name is Katie An and I have swam competitively for about 6 years with Pacific Swim. I am a high school student in the class of 2028, and I have been on Westview High School’s varsity swim team since freshman year. I am a primary butterflier and am working towards qualifying for CIFs. 🌟',
          picture: '/team-photos/KatieProfilePicture.jpg'
        },
        {
          id: 20,
          name: 'Ryker Liu',
          location: 'California',
          club: 'Pacific Swim',
          bio: 'Patient coach who excels at teaching beginners and building strong foundations! 🌟',
          picture: '/team-photos/Yimo_brother.jpg'
        }
      ]
    }
  };

  return (
    <div className="team">
      <div className="container">
        <section className="section">
          <h2>Team</h2>
          
          <div className="card">
            <h3>Meet Our Amazing Coaches! 🌊</h3>
            <p>Our coaches are competitive swimmers from some of the nation’s top clubs, dedicated to teaching swimming skills and water safety to our community.</p>
          </div>
          
          {Object.entries(teams).map(([teamKey, team]) => (
            <div key={teamKey} className="team-section">
              <div className="card">
                <h3>{team.name}</h3>
                <div className="team-grid">
                  {team.members.map(member => (
                    <div key={member.id} className="team-card">
                      <div className="team-photo">
                        <img 
                          src={member.picture} 
                          alt={`${member.name} - ${member.club}`}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        <div className="team-avatar-fallback">🏊‍♂️</div>
                      </div>
                      <h4>{member.name}</h4>
                      <p className="team-location">{member.location}</p>
                      <p className="team-club">{member.club}</p>
                      <p className="team-bio">{member.bio}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default Team; 